// @flow
import queryString from 'qs';

export default {
  stringify(params: any) {
    return queryString.stringify(params, { arrayFormat: 'bracket' });
  },
  parse(string: string) {
    return queryString.parse(string, { arrayFormat: 'bracket' });
  },
};



// WEBPACK FOOTER //
// ./src/common/utils/queryString.js